var render = function render() {
    var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
    return _c('div', {
        staticClass: "page"
    }, [
        _vm._m(0),
        _c('van-form', {
            ref: "idMessageRef",
            on: {
                "submit": _setup.onSubmit,
                "failed": _setup.onFailed
            }
        }, [
            _c('div', {
                staticClass: "card"
            }, [
                _c('div', {
                    staticClass: "card-title"
                }, [
                    _vm._v("INE / IFE")
                ]),
                _c('div', {
                    staticClass: "card-content"
                }, [
                    !_setup.idImgSrc ? _c('img', {
                        attrs: {
                            "src": require("@/assets/img/credit/idCard.png"),
                            "alt": ""
                        }
                    }) : _vm._e(),
                    _setup.idImgSrc ? _c('img', {
                        attrs: {
                            "src": _setup.idImgSrc
                        }
                    }) : _c('img', {
                        staticClass: "upload-btn",
                        attrs: {
                            "src": require("@/assets/img/credit/upload-idcard-btn.png"),
                            "alt": ""
                        },
                        on: {
                            "click": _setup.uploadIDcard
                        }
                    }),
                    _setup.idImgSrc ? _c('div', {
                        staticClass: "little-icon",
                        on: {
                            "click": _setup.uploadIDcard
                        }
                    }, [
                        _c('i'),
                        _c('span', [
                            _vm._v("Re-subir")
                        ])
                    ]) : _vm._e()
                ]),
                _c('div', {
                    staticClass: "card-tips"
                }, [
                    _vm._v(" * Te garantizamos que esta función se utiliza únicamente para la verificación de identidad y en ningún caso se compartirá con terceros. ")
                ])
            ]),
            _setup.idImgSrc ? _c('div', {
                staticClass: "form-box"
            }, [
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.idNo ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("CURP")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "idNo",
                            "clearable": "",
                            "placeholder": "CURP",
                            "rules": [
                                {
                                    required: true,
                                    message: 'CURP'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrackID('ID_number');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrackID('ID_number');
                            }
                        },
                        model: {
                            value: _setup.idNo,
                            callback: function callback($$v) {
                                _setup.idNo = $$v;
                            },
                            expression: "idNo"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.fullName ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Nombre y Apellido")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "fullName",
                            "clearable": "",
                            "placeholder": "Nombre y Apellido",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Nombre y Apellido'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrackID('name');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrackID('name');
                            }
                        },
                        model: {
                            value: _setup.fullName,
                            callback: function callback($$v) {
                                _setup.fullName = $$v;
                            },
                            expression: "fullName"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.textSex ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Género")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "textSex",
                            "value": _setup.textSex,
                            "label": "",
                            "placeholder": "Género",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Género'
                                }
                            ],
                            "right-icon": _setup.showPickerSex ? '' : 'arrow'
                        },
                        on: {
                            "click": function($event) {
                                _setup.showPickerSex = true;
                            }
                        }
                    }),
                    _c(_setup.SelectPopup, {
                        attrs: {
                            "title": 'Género',
                            "columns": _setup.columnsSex,
                            "selection": String(_setup.codeSex)
                        },
                        on: {
                            "closePopup": function($event) {
                                _setup.showPickerSex = false;
                            },
                            "confirm": _setup.onConfirmSex,
                            "click-close-icon": function($event) {
                                return _setup.onClosePopupTrack('gender', 0);
                            }
                        },
                        model: {
                            value: _setup.showPickerSex,
                            callback: function callback($$v) {
                                _setup.showPickerSex = $$v;
                            },
                            expression: "showPickerSex"
                        }
                    })
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.birthday ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Fecha de Nacimiento")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "readonly": "",
                            "clickable": "",
                            "name": "birthday",
                            "value": _setup.birthday,
                            "label": "",
                            "placeholder": "Fecha de Nacimiento",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Fecha de Nacimiento'
                                }
                            ],
                            "right-icon": _setup.showPickerBirthday ? '' : 'arrow'
                        },
                        on: {
                            "click": function($event) {
                                _setup.showPickerBirthday = true;
                            }
                        }
                    }),
                    _c('x-popup', {
                        staticStyle: {
                            "height": "60%",
                            "width": "100%",
                            "border-radius": "20px 20px 0 0"
                        },
                        attrs: {
                            "title": "Fecha de nacimiento",
                            "position": "bottom",
                            "get-container": "body",
                            "safeAreaInsetBottom": "",
                            "close-on-click-overlay": false
                        },
                        on: {
                            "input": function($event) {
                                return _vm.$emit('input', $event);
                            }
                        },
                        model: {
                            value: _setup.showPickerBirthday,
                            callback: function callback($$v) {
                                _setup.showPickerBirthday = $$v;
                            },
                            expression: "showPickerBirthday"
                        }
                    }, [
                        _c('van-datetime-picker', {
                            attrs: {
                                "type": "date",
                                "title": "Seleccione",
                                "min-date": _setup.minDate,
                                "max-date": _setup.maxDate
                            },
                            on: {
                                "confirm": _setup.onConfirmBirthday,
                                "cancel": function($event) {
                                    _setup.showPickerBirthday = false;
                                    _setup.onClosePopupTrack('birthday', 0);
                                }
                            },
                            model: {
                                value: _setup.defaultDate,
                                callback: function callback($$v) {
                                    _setup.defaultDate = $$v;
                                },
                                expression: "defaultDate"
                            }
                        })
                    ], 1)
                ], 1),
                _c('div', {
                    staticClass: "form-item"
                }, [
                    _setup.dueDate ? _c('div', {
                        staticClass: "item-title"
                    }, [
                        _vm._v("Año de Expiración del INE")
                    ]) : _vm._e(),
                    _c('van-field', {
                        attrs: {
                            "error": false,
                            "name": "dueDate",
                            "clearable": "",
                            "placeholder": "Año de Expiración del INE",
                            "rules": [
                                {
                                    required: true,
                                    message: 'Año de Expiración del INE'
                                }
                            ]
                        },
                        on: {
                            "focus": function($event) {
                                return _setup.onFocusTrackID('expiry_date');
                            },
                            "blur": function($event) {
                                return _setup.onBlurTrackID('expiry_date');
                            }
                        },
                        model: {
                            value: _setup.dueDate,
                            callback: function callback($$v) {
                                _setup.dueDate = $$v;
                            },
                            expression: "dueDate"
                        }
                    })
                ], 1)
            ]) : _vm._e(),
            _c(_setup.PrivacyDataBox, {
                on: {
                    "popup-click": function($event) {
                        _setup.agreed = true;
                    }
                },
                model: {
                    value: _setup.agreed,
                    callback: function callback($$v) {
                        _setup.agreed = $$v;
                    },
                    expression: "agreed"
                }
            }),
            _c(_setup.CreditFirstRetainPopup, {
                attrs: {
                    "step": 3
                },
                on: {
                    "close": function($event) {
                        _setup.isShowFirstRetainPopup = false;
                    },
                    "show-second": _setup.showSecondRetainPopup
                },
                model: {
                    value: _setup.isShowFirstRetainPopup,
                    callback: function callback($$v) {
                        _setup.isShowFirstRetainPopup = $$v;
                    },
                    expression: "isShowFirstRetainPopup"
                }
            }),
            _c(_setup.CreditSecondRetainPopup, {
                on: {
                    "close": function($event) {
                        _setup.isShowSecondRetainPopup = false;
                    },
                    "go-home": _setup.goAppHome
                },
                model: {
                    value: _setup.isShowSecondRetainPopup,
                    callback: function callback($$v) {
                        _setup.isShowSecondRetainPopup = $$v;
                    },
                    expression: "isShowSecondRetainPopup"
                }
            }),
            _c('van-button', {
                staticClass: "submit",
                attrs: {
                    "native-type": "submit"
                }
            }, [
                _vm._v("Siguiente")
            ])
        ], 1)
    ], 1);
};
var staticRenderFns = [
    function() {
        var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
        return _c('div', {
            staticClass: "progress"
        }, [
            _c('img', {
                attrs: {
                    "src": require("@/assets/img/credit/step3.png")
                }
            })
        ]);
    }
];
export { render, staticRenderFns };
